import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../apiService.js";
import ALERT from "../component/Alert";

class SubjectivePsikologi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].anamnese
        : "",
      eval: props.patient.anamneses[0] ? props.patient.anamneses[0].eval : "0",
      id: props.patient.anamneses[0] ? props.patient.anamneses[0].id : "",
      nursing_anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].nursing_anamnese
        : "-",
      treat: props.patient.anamneses[0]
        ? props.patient.anamneses[0].treat
        : "-",
      visit_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_id
        : props.patient.id,
      visit_inpatient_detail_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_inpatient_detail_id
        : "0",
      rekonsiliasi_obat: props.patient.anamneses[0]
        ? typeof props.patient.anamneses[0].rekonsiliasi_obat == "string"
          ? JSON.parse(props.patient.anamneses[0].rekonsiliasi_obat)
          : [
              {
                name: "",
                signa1: "",
                signa2: "",
                status: "",
              },
            ]
        : [
            {
              name: "",
              signa1: "",
              signa2: "",
              status: "",
            },
          ],
      kajian: null,
      alo_auto: "Autoanamnesis",
      responden: "",
      rps: props.patient.anamneses[0] ? props.patient.anamneses[0].rps : "",
    };
    this.fetchKajian = this.fetchKajian.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.patient.anamneses[0] !== prevProps.patient.anamneses[0]) {
      this.setState({
        anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].anamnese
          : "",
        eval: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].eval
          : "0",
        id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].id
          : "",
        nursing_anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].nursing_anamnese
          : "-",
        treat: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].treat
          : "-",
        visit_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_id
          : this.props.patient.id,
        visit_inpatient_detail_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_inpatient_detail_id
          : "0",
        wawancara: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].wawancara
          : "",
        observasi: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].observasi
          : "",
        alo_auto: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].alo_auto
          : "",
        responden: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].responden
          : "",
        rps: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].rps
          : "",
        pregnant_status: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].pregnant_status
          : "-",
      });
    }
  }

  handleTextChange = (e) => {
    let anamneses = [];
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        anamneses = { data: [this.state], param: "anamneses" };
        // console.log(this.state);
        this.props.parentCallback(anamneses);
      }
    );
  };
  handleSubmit = (e) => {
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.props.nextTab();
  };
  PostData = async () => {
    let param = {
      ...this.state,
      rekonsiliasi_obat: JSON.stringify(this.state.rekonsiliasi_obat),
    };
    const res = await API.post("management/anamneses/create", param);
    // console.log(res);
    if (res.code === 200) {
      if (res.code === 200) {
        ALERT("success", "Berhasil Menyimpan Data ");
        let anamneses = { data: [res.data], param: "anamneses" };
        this.props.parentCallback(anamneses);
      } else {
        ALERT("error", "gagal menyimpan data");
      }
    }
  };

  PutData = async () => {
    let param = {
      ...this.state,
      rekonsiliasi_obat: JSON.stringify(this.state.rekonsiliasi_obat),
    };
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
      let anamneses = { data: [res.data], param: "anamneses" };
      this.props.parentCallback(anamneses);
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  fetchKajian = async () => {
    // let res = await apiService.get(`management/kajian_awal/result/1378/umum`);
    let res = await API.get(
      `management/kajian_awal/result_patient/${this.props.patient.id}/dokter`
    );
    if (res) {
      let x = res.data.find((e) => e.name == "ANAMNESIS (S)");
      this.setState({ kajian: x });
    }
  };
  componentDidMount() {
    this.props.getData?.();
    this.fetchKajian();
  }

  render() {
    // console.log(this.props.patient);
    return (
      <>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Cek Status Hamil Pasien
          </label>
          <div className="col-md-7">
            <div className="row">
              <select
                className="form-control form-control-sm col-md-6"
                name="pregnant_status"
                onChange={this.handleTextChange}
                value={this.state?.pregnant_status}
              >
                <option value="-">Tidak</option>
                <option value="Hamil">Hamil</option>
                <option value="K1">K1</option>
                <option value="K2">K2</option>
                <option value="K3">K3</option>
                <option value="K4">K4</option>
                <option value="K5">K5</option>
                <option value="K6">K6</option>
              </select>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Alloanamnesis / Autoanamnesis
          </label>
          <div className="col-md-7">
            <div className="row">
              <select
                className="form-control form-control-sm col-md-6"
                name="alo_auto"
                onChange={this.handleTextChange}
                value={this.state.alo_auto}
              >
                <option value="Alloanamnesis">Alloanamnesis</option>
                <option value="Autoanamnesis">Autoanamnesis</option>
              </select>
            </div>
          </div>
        </div>
        {this.state.alo_auto == "Alloanamnesis" ? (
          <div className="form-group row">
            <label
              htmlFor="example-text-input"
              className="col-md-5 col-form-label col-form-label-sm"
            >
              yang diwawancarai
            </label>
            <div className="col-md-7">
              <div className="row">
                <input
                  className="form-control form-control-sm col-md-6"
                  name="responden"
                  onChange={this.handleTextChange}
                  value={this.state.responden}
                />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {/* <div className="form-group row">
                    <label
                        htmlFor="example-text-input"
                        className="col-md-5 col-form-label col-form-label-sm"
                    >
                        Anamnese Keperawatan
                    </label>
                    <div className="col-md-7">
                        <div className="row">
                            <textarea
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="Keluhan Pasien"
                                value={this.state.nursing_anamnese}
                                disabled
                            />
                        </div>
                    </div>
                </div> */}
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Keluhan Utama
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="Keluhan Pasien"
                name="anamnese"
                onChange={this.handleTextChange}
                value={this.state.anamnese}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Riwayat Penyakit Sekarang
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="RIWAYAT PENYAKIT SEKARANG"
                name="rps"
                onChange={this.handleTextChange}
                value={this.state.rps}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Wawancara
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                placeholder="Wawancara"
                name="wawncara"
                onChange={(e) => this.setState({ wawancara: e.target.value })}
                value={this.state.wawancara}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Observasi
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                placeholder="Observasi"
                name="observasi"
                onChange={(e) => this.setState({ observasi: e.target.value })}
                value={this.state.observasi}
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <h4>Riwayat Penyakit (Sesuai Kajian Awal)</h4>
          <div className="col-md-12">
            <div className="row">
              <table className="table align-items-center table-flush table-responsive">
                <thead className="thead-light">
                  <tr>
                    {this.state.kajian?.ref_kajian?.map((a, k) => {
                      if (k > 0) {
                        return <th key={a.id}>{a.list[0]?.label}</th>;
                      }
                    })}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {this.state.kajian?.ref_kajian?.map((a, k) => {
                      if (k > 0) {
                        return <td key={a.id}>{a.list[0]?.result?.result}</td>;
                      }
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <button className="btn btn-primary" onClick={this.handleSubmit}>
          Simpan
        </button>
        <button className="btn btn-danger" onClick={this.onReload}>
          Tutup
        </button>
      </>
    );
  }
}

export default SubjectivePsikologi;
